import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.object.to-string.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from 'prop-types';
import { ObjectAssign } from './util';
/**
 * 参数: 单选表头
 * @param {*} Table
 * @param {*} Radio
 */

export default function singleSelect(Table, Radio) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(SingleSelect, _Component);

    var _super = _createSuper(SingleSelect);

    function SingleSelect(props) {
      var _this;

      _classCallCheck(this, SingleSelect);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "handleRadioClick", function (e) {
        e.stopPropagation();
      });

      _defineProperty(_assertThisInitialized(_this), "onRadioChange", function (value, record, index) {
        var selectedRowIndex = _this.state.selectedRowIndex;

        if (selectedRowIndex === index) {
          _this.setState({
            selectedRowIndex: ''
          });

          _this.props.getSelectedDataFunc();
        } else {
          _this.setState({
            selectedRowIndex: index
          });

          _this.props.getSelectedDataFunc(record, index);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "getDefaultColumns", function (columns) {
        var selectedRowIndex = _this.state.selectedRowIndex;
        var _defaultColumns = [{
          title: '',
          key: "radio",
          dataIndex: "radio",
          fixed: "left",
          width: 49,
          render: function render(text, record, index) {
            return /*#__PURE__*/React.createElement(Radio.Group, {
              className: "table-radio",
              name: "table-radio",
              selectedValue: selectedRowIndex,
              onClick: _this.handleRadioClick,
              onChange: function onChange(value) {
                return _this.onRadioChange(value, record, index);
              },
              style: {
                width: '14px',
                height: '14px',
                display: 'block',
                marginLeft: '4px'
              }
            }, /*#__PURE__*/React.createElement(Radio, {
              value: index
            }));
          }
        }];
        return _defaultColumns.concat(columns);
      });

      _defineProperty(_assertThisInitialized(_this), "onRowClick", function (record, index, event) {
        var _this$props = _this.props,
            autoCheckedByClickRows = _this$props.autoCheckedByClickRows,
            onRowClick = _this$props.onRowClick;

        if (autoCheckedByClickRows) {
          _this.onRadioChange('', record, index);
        }

        onRowClick && onRowClick(record, index, event);
      });

      _defineProperty(_assertThisInitialized(_this), "getRowClassName", function (record, index, event) {
        var selectedRowIndex = _this.state.selectedRowIndex;

        if (index === selectedRowIndex) {
          return 'selected';
        } else {
          return '';
        }
      });

      _this.state = {
        data: ObjectAssign(props.data),
        selectedRowIndex: props.selectedRowIndex
      };
      return _this;
    }

    _createClass(SingleSelect, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if ('data' in nextProps) {
          this.setState({
            data: ObjectAssign(nextProps.data)
          });
        }

        if ('selectedRowIndex' in nextProps) {
          this.setState({
            selectedRowIndex: nextProps.selectedRowIndex
          });
        }
      }
      /**
       * 判断是否是数组
       * @param {*} o 
       */

    }, {
      key: "isArray",
      value: function isArray(o) {
        return Object.prototype.toString.call(o) == '[object Array]';
      }
    }, {
      key: "render",
      value: function render() {
        var columns = this.props.columns;
        var data = this.state.data;
        return /*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
          columns: this.getDefaultColumns(columns),
          data: data,
          onRowClick: this.onRowClick,
          rowClassName: this.getRowClassName
        }));
      }
    }]);

    return SingleSelect;
  }(Component), _defineProperty(_class, "propTypes", {
    autoCheckedByClickRows: PropTypes.bool //行点击时，是否自动勾选单选框

  }), _defineProperty(_class, "defaultProps", {
    prefixCls: "u-table-single-select",
    getSelectedDataFunc: function getSelectedDataFunc() {},
    selectedRowIndex: '',
    autoCheckedByClickRows: true
  }), _temp;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/lib/singleSelect.js